import importerStore from '@/shared/importer/importer-store';
import { GuideService } from '@/modules/guide/guide-service';
import guideImporterFields from '@/modules/guide/guide-importer-fields';
import { i18n } from '@/i18n';

export default importerStore(
  GuideService.import,
  guideImporterFields,
  i18n('entities.guide.importer.fileName'),
  i18n('entities.guide.importer.hint'),
);
